import React from "react";
import { CHECKOUT_WIZARD_STEPS, CheckoutWizardStepId } from "./checkoutWizard.constants";

interface CheckoutMobileProgressProps {
  currentStep: CheckoutWizardStepId;
}

export const CheckoutMobileProgress: React.FC<CheckoutMobileProgressProps> = ({ currentStep }) => {
  const stepMeta = CHECKOUT_WIZARD_STEPS[currentStep];
  const progressPercent = ((currentStep + 1) / CHECKOUT_WIZARD_STEPS.length) * 100;

  return (
    <header className="border-b border bg-background px-4 py-4 lg:hidden">
      <p className="font-semibold text-foreground">Finalizar compra</p>
      <p className="mt-1 text-xs text-text-secondary">
        Passo {currentStep + 1} de {CHECKOUT_WIZARD_STEPS.length} — {stepMeta.label}
      </p>
      <div
        className="mt-3 h-1.5 overflow-hidden rounded-full bg-gray-200"
        role="progressbar"
        aria-valuenow={progressPercent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`Progresso do checkout: passo ${currentStep + 1}`}
      >
        <div
          className="h-full rounded-full bg-success-subtle transition-[width] duration-300 ease-out motion-reduce:transition-none"
          style={{ width: `${progressPercent}%` }}
        />
      </div>
    </header>
  );
};
